import styled from 'styled-components'

const FormBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${props => props.justifyContent ? props.justifyContent : 'flex-start'};
  margin-top: ${props => props.marginTop}px;
  margin-bottom: ${props => props.marginBottom}px;
  padding-left: ${props => props.paddingLeft}px;
  padding-right: ${props => props.paddingRight}px;
`

export default FormBlock



// WEBPACK FOOTER //
// ./src/components/signin/FormBlock.js